import { ListFlagsCase } from './domain/useCases/ListFlagsCase'
import { UpdateAllFlagsCase } from './domain/useCases/UpdateAllFlagsCase'
import { flagsDatasourceAdapter } from './external/flagsDatasourceAdapter'
import { flagsRepositoryAdapter } from './infra/flagsRepositoryAdapter'

export const flagInstance = {
  listFlags: ListFlagsCase(flagsRepositoryAdapter(flagsDatasourceAdapter)),
  updateAllFlagsCase: UpdateAllFlagsCase(
    flagsRepositoryAdapter(flagsDatasourceAdapter)
  )
}
